@if (showToast) {
    <div class="update-toast" role="alert">
        <div class="update-toast__icon">⬆</div>
        <div class="update-toast__body">
            <div class="update-toast__title">Update available</div>
            <div class="update-toast__sub">
                Version {{ updater.latestVersion() }} is ready to download.
            </div>
        </div>
        <div class="update-toast__actions">
            <button type="button" class="btn btn-primary" (click)="onDownload()">Download</button>
            <button type="button" class="btn btn-ghost" (click)="onLater()">Later</button>
        </div>
    </div>
}

@if (showProgress) {
    <div class="update-toast update-toast--progress" role="status">
        <div class="update-toast__body">
            <div class="update-toast__title">Downloading v{{ updater.latestVersion() }}</div>
            <div class="update-progress">
                <div class="update-progress__bar" [style.width.%]="updater.progressPercent()"></div>
            </div>
            <div class="update-toast__sub">{{ updater.progressPercent() }}%</div>
        </div>
    </div>
}

@if (showReady) {
    <div class="update-dialog-backdrop">
        <div class="update-dialog" role="dialog" aria-modal="true">
            <h3 class="update-dialog__title">Update ready</h3>
            <p class="update-dialog__body">
                Version {{ updater.latestVersion() }} has been downloaded.
                Restart now to apply the update, or it will install automatically when you close the app.
            </p>
            <div class="update-dialog__actions">
                <button type="button" class="btn btn-primary" (click)="onInstall()">Restart now</button>
                <button type="button" class="btn btn-ghost" (click)="onLater()">On next launch</button>
            </div>
        </div>
    </div>
}
